import React, { useEffect } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import AssigComp from "../components/assig-comp";

function Assignment() {
  useEffect(() => {
    // 1. Script load karne ka helper function
    const loadScript = (src) => {
      return new Promise((resolve, reject) => {
        // Agar script pehle se load hai to skip karein
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = false; // Sequence maintain karne ke liye false
        
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Script load failed: ${src}`));

        document.body.appendChild(script);
      });
    };

    // 2. Scripts List (Sahi tartib)
    const scripts = [
      "assets/js/jquery.js",
      "assets/js/bootstrap.bundle.min.js",
      "assets/js/purecounter.js",
      "assets/js/range-slider.js",
      "assets/js/nice-select.js",
      "assets/js/swiper-bundle.min.js",
      "assets/js/isotope-pkgd.js",
      "assets/js/slick.min.js",
      "assets/js/wow.js",
      "assets/js/countdown.js",
      "assets/js/magnific-popup.js",
      "assets/js/imagesloaded-pkgd.js",
      "assets/js/parallax.js",
      "assets/js/slider.js",
      "assets/js/main.js"
    ];

    // 3. Load Function
    const loadAllScripts = async () => {
      try {
        for (const src of scripts) {
          await loadScript(src); // Wait karega jab tak pichli file load na ho jaye
        }
      } catch (error) {
        console.error("Script loading error:", error);
      }
    };

    loadAllScripts();

    // Cleanup
    return () => {
      scripts.forEach(src => {
        const script = document.querySelector(`script[src="${src}"]`);
        if (script) {
          document.body.removeChild(script);
        }
      });
    };
  }, []);

  return (
    <>
      <Header />
      <AssigComp />
      <Footer />
    </>
  );
}

export default Assignment;